<kendo-dialog title="{{'_Shared_ModelPopUp_Licensing_Permission_Header_Text_' | translate : { val1: productLicense?.ProductDisplayName } }}" [width]="700" (close)="close()">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="table-wrapper">
    <p class="mb-3">{{'_Shared_NodelPopUp_Licensing_Permission_Body_Paragraph_One_Text_' | translate : { val1: productLicense?.ProductDisplayName, val2: productLicense?.ProductDisplayName } }}</p>
    <p class="mb-3">{{'_Shared_ModelPopUp_Licensing_Permission_Body_Paragraph_Two_Text_' | translate : { val1: selectedProductLicense?.ProductDisplayName } }}</p>
    <div class="ps-list mx-3">
      <ol>
        <li class="mb-2">{{'_Shared_ModelPopUp_Licensing_Permission_Body_List_One_Text_' | translate }}</li>
        <li class="mb-2">{{'_Shared_ModelPopUp_Licensing_Permission_Body_List_Two_Text_' | translate : { val1: selectedProductLicense?.ProductDisplayName, val2: productLicense?.ProductDisplayName } }}</li>
        <li>{{'_Shared_ModelPopUp_Licensing_Permission_Body_List_Three_Text_' | translate : { val1: productLicense?.ProductDisplayName } }}</li>
      </ol>
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel" class="cc-btn-panel">
    <button class="btn btn-primary" primary="true" (click)="close()">{{'_General_Button_Ok_Text_' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>
